import {inject, NgModule} from '@angular/core';
import {provideApollo} from 'apollo-angular';
import {environment} from '../environments/environment';
import {HttpLink} from 'apollo-angular/http';
import {InMemoryCache} from '@apollo/client/core';

const uri: string = `${environment.publicApiUrl}/api/graphql`;

@NgModule({
    imports: [],
    providers: [
        provideApollo(() => {
            const httpLink = inject(HttpLink);

            return {
                link: httpLink.create({uri}),
                cache: new InMemoryCache(),
                connectToDevTools: true,
                defaultOptions: {
                    watchQuery: {
                        fetchPolicy: 'network-only',
                        errorPolicy: 'ignore',
                    },
                    query: {
                        fetchPolicy: 'network-only',
                        errorPolicy: 'all',
                    },
                    mutate: {
                        errorPolicy: 'all'
                    }
                }
            };
        }),
    ],
})
export class GraphQLModule {
}
